const actionQueue = new Map();

export default function queue(key, now, later) {
    let lastJob = {};
    if (actionQueue.has(key)) {
        lastJob = actionQueue.get(key);
    }

    const { optimisicUpdates = [], promise = Promise.resolve({}) } = lastJob;

    // eslint is wrong here. It needs to be defined above where it's used but we
    // don't have a value yet
    let currentJob; // eslint-disable-line prefer-const
    function cleanup(x) {
        optimisicUpdates.shift();
        optimisicUpdates.forEach(fn => fn());

        if (actionQueue.get(key) === currentJob) {
            actionQueue.delete(key);
        }

        return {};
    }
    function cleanupError(err) {
        console.log('err: ', err); // eslint-disable-line no-console
        return cleanup(err);
    }

    now();
    optimisicUpdates.push(now);

    // Fork the promise chain. The caller might want to know if their
    // promise succeeds or fails, so we don't want to return
    // currentJob.promise because it always succeeds and resolves to an
    // empty object.
    const ret = promise.then(later);

    // This can't be made a `const` because it needs to be in scope for `cleanup()`
    currentJob = {
        //eslint-disable-line prefer-const
        // It doesn't matter if the promises succeeds or fails. Clean it up
        // here and continue the chain
        promise: ret.then(cleanup, cleanupError),
        optimisicUpdates,
    };
    actionQueue.set(key, currentJob);
    return ret;
}



// WEBPACK FOOTER //
// ./src/actions/utils/request_queue.js